import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'reactstrap';
import { FieldArray } from 'formik';
import { FormInputField } from '../../../common/components/formFields';

const DealerAdditionalEmailsForm = ({ additionalEmails }) => {
  const err = (index, arrayHelpers, name) => {
    if (arrayHelpers?.form?.errors?.additionalEmails) {
      const errors = arrayHelpers?.form?.errors?.additionalEmails?.[index];
      const touched = arrayHelpers?.form?.touched?.additionalEmails?.[index];
      if (errors?.[name] && (touched || touched?.[name])) {
        return <label className="error-label">{errors?.[name]}</label>;
      }
    }
    return false;
  };

  return (
    <>
      <h6>Additional accounts emails</h6>
      <FieldArray
        name="additionalEmails"
        render={arrayHelpers => (
          <div>
            {additionalEmails.map((additionalEmail, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={index}>
                <Col md="6" sm="8" xs="8">
                  <FormInputField name={`additionalEmails.${index}.email`} label="Email" />
                  {err(index, arrayHelpers, 'email')}
                </Col>
                <Col>
                  <Button
                    className="dealer-additional-emails-delete-btn"
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    <i className="fas fa-times" />
                  </Button>
                </Col>
              </Row>
            ))}
            <Row>
              <Button color="neutral" type="button" onClick={() => arrayHelpers.push('')}>
                Add additional account email
              </Button>
            </Row>
          </div>
        )}
      />
    </>
  );
};

DealerAdditionalEmailsForm.defaultProps = {
  additionalEmails: [],
};

DealerAdditionalEmailsForm.propTypes = {
  additionalEmails: PropTypes.array,
};

export default DealerAdditionalEmailsForm;
